import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, Text, StyleSheet } from 'react-native';
import { ProcessTypes, getFirstBookingForDay } from 'fitbeat.gym-core';

import Theme from '../../theme';
import { getNextBookingStep, setWorkoutSession } from '../actions';
import { Logger, i18n, getSlotTime, getMomentFormat } from '../../utils';
import { styles as sharedStyles } from './Styles';
import { ConfirmAction } from '../components';
import { showToastMessage, inviteCancelledToast } from '../../ui';
import { getGymTimezone } from '../../utils/gyms';

class ChangeInvite extends Component {
  static getSubtitle = ({ workoutSession, gymTimezone }) => (
    <View style={sharedStyles.subtitleContainer}>
      <Text style={sharedStyles.subtitle}>
        {getMomentFormat(workoutSession.startTimeOfFirstExercise, 'DD MMM', gymTimezone)}
      </Text>
      <View style={sharedStyles.verticalSeparator} />
      <Text style={sharedStyles.subtitle}>
        {getMomentFormat(workoutSession.startTimeOfFirstExercise, 'HH:mm', gymTimezone)}
      </Text>
      <View style={sharedStyles.verticalSeparator} />
      <Text style={sharedStyles.subtitle}>
        {getSlotTime(workoutSession)}
      </Text>
    </View>
  );

  state = {
    error: null,
    isLoading: false,
  };

  setIsLoading = (isLoading) => {
    this.setState({ isLoading });
  }

  setError = (error) => {
    this.setState({ error });
  }

  clearError = () => {
    this.setError(null);
  }

  cancelInvite = async () => {
    const {
      day,
      workoutSessionService: { cancelInvite },
      workoutSession,
      userProfile,
      setWorkoutSession,
      getNextBookingStep,
    } = this.props;
    try {
      this.clearError();
      this.setIsLoading(true);
      await cancelInvite(workoutSession.uniqueReference);
      this.props.showToastMessage(inviteCancelledToast(moment(workoutSession.startTimeOfFirstExercise).format('dddd, Do MMMM')));
      setWorkoutSession(workoutSession);
      getNextBookingStep(userProfile, ProcessTypes.Cancel);
    } catch (error) {
      this.setError(error)
      Logger.notify(error);
    } finally {
      this.setIsLoading(false);
    }
  }

  changePartner = () => {
    const { getNextBookingStep, userProfile } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.ChangePartner);
  }

  render() {
    const { t } = this.props;
    const { error, isLoading } = this.state;

    return (
      <View style={sharedStyles.containerNoPadding}>
        <ConfirmAction
          title={t('changeInvite')}
          subtitle={t('cancelOrChangeParterConfirmation')}
          leftButtonText={t('cancelInvite')}
          rightButtonText={t('changePartner')}
          leftButtonPress={this.cancelInvite}
          rightButtonPress={this.changePartner}
          isLoading={isLoading}
          error={error}
        />
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    showToastMessage: (toast) => dispatch(showToastMessage(toast)),
    setWorkoutSession: (booking) => dispatch(setWorkoutSession(booking)),
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
  };
};

ChangeInvite = connect(mapStateToProps, mapDispatchToProps)(ChangeInvite);
export default translate(['bookings'], { wait: true })(ChangeInvite);
